<template>
  <div class="p-welcome__body-background">
    <div class="p-welcome__little-center">
      <img class="p-welcome__little-pic" src="~@/assets/images/welcome/group15.png" />
      <div class="p-welcome__little-one">WELCOME</div>
      <div class="p-welcome__little-two">欢迎进入{{ appName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    appName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.p-welcome__body-background {
  width: 100%;
  height: 100vh;
  background: url("~@/assets/images/welcome/frame5.png") no-repeat;
  background-size: cover;
  button {
    margin-top: 12px;
    margin-left: 20px;
  }
}

.p-welcome__little-center {
  display: flex;
  flex-direction: column;
  align-items:center;
  .p-welcome__little-pic {
      width: 350px;
      height: 350px;
      margin-top: 50px;
      margin-bottom: 50px;
  }
  .p-welcome__little-one {
  font-size: 36px;
  font-family: SF Pro Display-Regular, SF Pro Display;
  color: #5891E1;
  letter-spacing: 6px;
  margin-bottom:0.1rem;
  text-align: center;
  }
  .p-welcome__little-two {
    font-size: 22px;
    font-family: PingFang SC-Medium, PingFang SC;
    color: #7EA8D7;
    letter-spacing: 2px;
    text-align: center;
  }
}

.phone-body {
  .p-welcome__little-pic {
    width: 3.2rem;
    height: 3.2rem;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }
  .p-welcome__little-one {
    font-size: 0.30rem;
    letter-spacing: 0.04rem;
  }
  .p-welcome__little-two {
    font-size: 0.22rem;
    letter-spacing: 0.02rem;
    padding: 0 0.3rem;
  }
}
.phone-body .ant-message {
  line-height: 87px;
  font-size: 43px;
  top: 28px;
  .ant-message-notice-content {
    padding: 14px 28px;
  }
}
.phone-body .ant-message .anticon {
  font-size: 43px;
}
</style>
